import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=09de168d&scoped=true"
import script from "./Allocation.vue?vue&type=script&lang=js"
export * from "./Allocation.vue?vue&type=script&lang=js"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=09de168d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de168d",
  null
  
)

export default component.exports